import React from 'react';
import classNames from 'classnames';

const toScore = value => {
  if (value === null || value === undefined || value === '') return null;
  const number = Number(value);
  return Number.isNaN(number) ? null : number;
};

const getClubImageUrl = imagePath =>
  imagePath ? `${process.env.REACT_APP_BASE_API_URL}/uploads/${imagePath}` : null;

const MatchScoreboard = ({ item }) => {
  const homeSets = toScore(item.home_sets_won);
  const awaySets = toScore(item.away_sets_won);
  const hasResult = homeSets !== null && awaySets !== null;
  const winner = hasResult && homeSets !== awaySets ? (homeSets > awaySets ? 'home' : 'away') : null;
  const sets = [1, 2, 3, 4, 5]
    .map(number => ({
      number,
      home: toScore(item[`home_set_${number}`]),
      away: toScore(item[`away_set_${number}`])
    }))
    .filter(set => set.home !== null && set.away !== null);

  const teams = [
    { side: 'home', club: 'club_1', fallback: 'Club 1', setsWon: homeSets },
    { side: 'away', club: 'club_2', fallback: 'Club 2', setsWon: awaySets }
  ];

  return (
    <div className="ms-2 py-1" style={{ maxWidth: '520px' }}>
      {teams.map(({ side, club, fallback, setsWon }, index) => {
        const isWinner = winner === side;
        const isLoser = winner && !isWinner;

        return (
          <div
            key={club}
            className={classNames('d-flex align-items-center gap-2', { 'mt-2': index })}
          >
            <div
              className={classNames('d-flex align-items-center gap-2 flex-grow-1', {
                'fw-semibold text-body-emphasis': isWinner,
                'text-body-tertiary': isLoser
              })}
              style={{ minWidth: 0 }}
            >
              {item[`${club}_image_path`] ? (
                <img
                  src={getClubImageUrl(item[`${club}_image_path`])}
                  alt={item[`${club}_name`] || fallback}
                  style={{ width: '22px', height: '22px', objectFit: 'cover', borderRadius: '50%', flexShrink: 0 }}
                />
              ) : (
                <span className="rounded-circle bg-body-secondary flex-shrink-0" style={{ width: '22px', height: '22px' }} />
              )}
              <span className="text-truncate">{item[`${club}_name`] || '-'}</span>
            </div>

            {hasResult && (
              <>
                <span
                  className={classNames('d-inline-flex align-items-center justify-content-center rounded-2 fw-bold flex-shrink-0', {
                    'bg-body-secondary text-body-emphasis': isWinner,
                    'text-body-tertiary': !isWinner
                  })}
                  style={{ width: '28px', height: '26px', fontSize: '0.875rem' }}
                  title="Osvojeni setovi"
                >
                  {setsWon}
                </span>
                <div className="d-flex flex-shrink-0 ps-2 border-start" style={{ gap: '2px', minWidth: '147px' }}>
                  {sets.map(set => {
                    const own = side === 'home' ? set.home : set.away;
                    const other = side === 'home' ? set.away : set.home;
                    const wonSet = own > other;

                    return (
                      <span
                        key={set.number}
                        className={classNames('text-center', {
                          'fw-bold text-body-emphasis': wonSet,
                          'text-body-tertiary': !wonSet
                        })}
                        style={{ width: '26px', fontVariantNumeric: 'tabular-nums' }}
                        title={`${set.number}. set: ${set.home}:${set.away}`}
                      >
                        {own}
                      </span>
                    );
                  })}
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default MatchScoreboard;
